import React, { useState, useCallback, useEffect } from 'react';
import Cropper from 'react-easy-crop';
import getCroppedImg from './cropImage'; // we'll define this separately
import { Modal } from 'react-bootstrap'; // optional if you're using Bootstrap modal
import { useAgentAuth } from './AgentAuthContext';
import AuthUser from '../../services/AuthUser';


const ProfileSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [showCrop, setShowCrop] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [finalImage, setFinalImage] = useState('assets/image/user.png');
  const { isAuthenticated } = useAgentAuth();
       const { http, token } = AuthUser();

  const getUserOrAgentData = () => {
    if (isAuthenticated) {
      // If authenticated as an agent, get agent data from localStorage
      return JSON.parse(localStorage.getItem("agent"));
    } else {
      // If not authenticated as an agent, get user data from localStorage
      return JSON.parse(localStorage.getItem("user"));
    }
  };

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const imageDataUrl = await readFile(file);
      setImageSrc(imageDataUrl);
      setShowCrop(true);
    }
  };

  const readFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result));
      reader.readAsDataURL(file);
    });
  };

  const endpoint = isAuthenticated
    ? '/upload-agent-profile' // Agent profile endpoint
    : '/upload-user-profile'; // User profile endpoint

    const showCroppedImage = useCallback(async () => {
        try {
          const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels, 'cropped.jpg');
          const formData = new FormData();
          formData.append('profile_picture', croppedImageBlob);
    
          const userOrAgent = getUserOrAgentData();
          if (!userOrAgent) {
            alert("User/Agent data is missing.");
            return;
          }
          formData.append('user_id', userOrAgent?.user_id || '');
    
          const response = await http.post(endpoint, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Ensure correct content type for form data
            },
          });
    
          // Accessing the response data directly
          const data = response.data;
    
          if (data.url) {
            localStorage.setItem('ProfileImage', data.url); // 🟢 Store for persistence
            setFinalImage(data.url); // Update image in UI
            setShowCrop(false);
            setShowModal(false);
    
            if (isAuthenticated) {
                // If authenticated as agent, update agent data
                localStorage.setItem('agent', JSON.stringify(data.agent)); // Update agent data in localStorage
            } else {
                // If authenticated as user, update user data
                localStorage.setItem('user', JSON.stringify(data.user)); // Update user data in localStorage
            }
    
            // Trigger an event to notify profile image update
            window.dispatchEvent(new Event('profileImageUpdated'));
    
            alert('Profile updated successfully!');
          } else {
            alert('Upload failed');
          }
        } catch (e) {
          console.error('Upload error:', e);
        
          if (e.response && e.response.data) {
            console.error('Server response:', e.response.data);
        
            // Optional: Show detailed message from server
            if (e.response.data.message) {
              alert(`Error: ${e.response.data.message}`);
            } else if (e.response.data.errors) {
              const errorMessages = Object.values(e.response.data.errors).flat().join('\n');
              alert(`Validation errors:\n${errorMessages}`);
            } else {
              alert('Upload failed with unknown error.');
            }
          } else {
            alert('Something went wrong while uploading.');
          }
        }
        
    }, [imageSrc, croppedAreaPixels]);
    

  useEffect(() => {

    if (isAuthenticated) {
        // If authenticated as agent, fetch agent data from localStorage
        const agentimg = JSON.parse(localStorage.getItem('agent'));
  
        if (agentimg && agentimg.profile_picture) {
          // If the agent has a profile_picture, update the finalImage state
         
          setFinalImage( agentimg.profile_picture);
          console.log('img ',finalImage)
        }
      } else {
        // If not authenticated as agent, fetch user data from localStorage
        const userData = JSON.parse(localStorage.getItem('user'));
  
        if (userData && userData.profile_picture) {
          // If the user has a profile_picture, update the finalImage state
        
          setFinalImage( userData.profile_picture);
        }
      }
 
  }, []);
  

  return (
    <>
      {/* Trigger */}
      <div onClick={() => setShowModal(true)} style={{ cursor: 'pointer' }}>
        <img src={finalImage} alt="Profile"   onError={(e) => e.target.src = 'assets/image/user.png'}
  className="rounded-circle border shadow-sm" style={{ width: 90, height: 90, objectFit: 'cover' }} />
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" tabIndex="-1" onClick={() => setShowModal(false)} style={{ backgroundColor: '#00000099' }}>
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content p-3 text-center">
              {!showCrop ? (
                <>
                  <img src={finalImage} className="mb-3" style={{ width: '100%', borderRadius: '0.5rem', objectFit: 'cover' }} />
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    id="profileInput"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="profileInput" className="btn btn-primary w-100 mb-2">Change Profile</label>
                  <button className="btn btn-outline-secondary w-100" onClick={() => setShowModal(false)}>Close</button>
                </>
              ) : (
                <>
                  <div style={{ position: 'relative', width: '100%', height: 300 }}>
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      onCropComplete={onCropComplete}
                    />
                  </div>
                  <button className="btn btn-success w-100 mt-3" onClick={showCroppedImage}>Set Profile</button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileSection;
